module.exports = __webpack_public_path__ + "img/poly-14.04478696.png";